import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  IconButton,
} from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import LogoHome from '../../utils/LogoHome';

const LogoSection = ({
  open,
  toggleDrawer,
}) => (
  <Box display="flex" flexDirection="row">
    {open ? (
      <>
        <LogoHome wrapperHeight={64} height={32} width={107} />
        <IconButton
          edge="start"
          aria-label="menu"
          color="secondary"
          onClick={toggleDrawer}
          size="large"
        >
          <NavigateBeforeIcon color="primary" />
        </IconButton>

      </>
    )
      : (
        <IconButton
          edge="start"
          aria-label="menu"
          color="secondary"
          onClick={toggleDrawer}
          size="large"
        >
          <NavigateNextIcon color="primary" />
        </IconButton>
      )}
  </Box>
);

LogoSection.propTypes = {
  open: PropTypes.bool,
  toggleDrawer: PropTypes.func,
};
export default LogoSection;
